"use client";

import { useRef } from "react";
import { usePathname, useRouter } from "next/navigation";
import { cn } from "@/lib/utils";
import { DEFAULT_LANGUAGE } from "@/sanity/globals/I18n";

const LANGUAGES: Record<string, { label: string }> = {
  de: { label: "CH" },
  en: { label: "EN" },
};

function getLanguagePath(
  targetLang: string,
  currentPath: string,
  currentLang: string,
): string {
  let basePath = currentPath;
  if (currentLang && currentLang !== DEFAULT_LANGUAGE) {
    basePath =
      currentPath.replace(new RegExp(`^\\/${currentLang}(\\/|$)`), "/") || "/";
  }
  if (targetLang === DEFAULT_LANGUAGE) return basePath || "/";
  return basePath === "/" ? `/${targetLang}` : `/${targetLang}${basePath}`;
}

export default function LanguageSwitcher({
  language = DEFAULT_LANGUAGE,
}: {
  language?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const pathname = usePathname();

  const entries = Object.entries(LANGUAGES);

  return (
    <div
      ref={ref}
      className="flex-shrink-0 border border-black/5 bg-[#F3F2F1] rounded-[1rem]"
    >
      <div className="bg-white/80 rounded-[1rem] p-[.25rem]">
        <div className="flex gap-[.25rem] bg-[#F3F2F1] rounded-[1rem] p-[.25rem]">
          {entries.map(([code, { label }], i) => (
            <button
              key={code}
              onClick={() => {
                router.push(getLanguagePath(code, pathname, language));
              }}
              disabled={code === language}
              className={cn(
                "flex items-center rounded-[0.75rem] w-full px-[1.25rem] py-[.25rem] lg:py-[.14rem] hover:bg-black/5 border border-white/0 hover:border-black/5 hover:opacity-100 transition-all duration-200",
                code === language
                  ? "opacity-100 bg-black/5 border-black/5"
                  : "opacity-40",
              )}
            >
              <span className="font-geist font-[500] text-[2rem] text-black">
                {label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
